import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div className="div_footer" style={{"left": this.props.left}}>
                <div className="hr-dashed"></div>
                <div className="wrapper">
                    <div className="left">
                        Copyright &copy; 2018 - 2019 Polycom, Inc. All rights reserved.
                    </div>
                    <div className="clear"></div>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/modules/main/Footer.js